import './GlobalPreferencePanel.scss';

import classNames from 'classnames';
import { useMemo, useState } from 'react';

import { ShowTo } from '../../ShowTo';
import MobileStickyFullLayout from '../../Layout/MobileStickyFullLayout';
import {
  SelectorId,
  SelectorType,
  globalPreferenceClassName,
} from './GlobalPreferencePanel';
import { isEnterKey } from '@travelwin/core';

const FullScreenGlobalPreferencePanel = ({
  isExpanded,
  selectors,
}: {
  isExpanded: boolean;
  selectors: SelectorType[];
  onClose: () => void;
}) => {
  const [currentTab, setCurrentTab] = useState<SelectorId>(
    selectors[0]?.id || 'language',
  );

  const renderTitles = useMemo(
    () => (
      <div className={`${globalPreferenceClassName}__tab`}>
        {selectors.map(({ id, title, showTo }) => (
          <ShowTo brands={showTo} key={id}>
            <div
              className={classNames(`${globalPreferenceClassName}__tab-item`, {
                [`${globalPreferenceClassName}__tab-item--activated`]:
                  currentTab === id,
              })}
              onClick={() => setCurrentTab(id)}
              onKeyDown={(e) => isEnterKey(e) && setCurrentTab(id)}
              tabIndex={0}
            >
              <span
                className={`${globalPreferenceClassName}__selector-list-title`}
              >
                {title}
              </span>
            </div>
          </ShowTo>
        ))}
      </div>
    ),
    [selectors, currentTab],
  );

  const renderSelector = useMemo(() => {
    const currentSelector = selectors.find(
      (selector) => selector.id === currentTab,
    );

    if (currentSelector)
      return (
        <div className={`${globalPreferenceClassName}__selector-list`}>
          <ShowTo brands={currentSelector.showTo}>
            {currentSelector.component}
          </ShowTo>
        </div>
      );
  }, [currentTab]);

  return (
    <MobileStickyFullLayout isExpanded={isExpanded}>
      <div className={`${globalPreferenceClassName}__wrapper-sticky-full`}>
        {renderTitles}
        {renderSelector}
      </div>
    </MobileStickyFullLayout>
  );
};

export default FullScreenGlobalPreferencePanel;
